import { Download, FileText } from 'lucide-react'
import type { OrganizationUpload as Upload } from '@/types'

interface FileInfoCardProps {
    upload: Upload
}

export default function FileInfoCard({ upload }: FileInfoCardProps) {
    return (
        <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg leading-6 font-medium text-gray-900">File Information</h3>
            </div>
            <div className="p-6">
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                        <FileText className="h-8 w-8 text-gray-400"/>
                        <div>
                            <p className="text-sm font-medium text-gray-900">{upload.filename}</p>
                            <p className="text-sm text-gray-500">
                                {(upload.filesize / 1024).toFixed(1)} KB
                            </p>
                        </div>
                    </div>
                    <a
                        href={`/admin/organization_uploads/${upload.id}/download_file`}
                        className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        download
                    >
                        <Download className="h-4 w-4 mr-2"/>
                        Download File
                    </a>
                </div>
            </div>
        </div>
    )
}